import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export function groupJoinLink(code) {
  return `https://clowza.com/groups/join/${String(code || '').toUpperCase()}`;
}

const JoinCodeQr = ({ code, size = 220 }) => {
  const [src, setSrc] = useState('');

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(groupJoinLink(code), {
      margin: 1,
      width: size,
      errorCorrectionLevel: 'M',
    })
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setSrc('');
      });
    return () => {
      cancelled = true;
    };
  }, [code, size]);

  if (!src) return null;

  return (
    <img
      src={src}
      alt={`Invite QR code for ${code}`}
      width={size}
      height={size}
      style={{ display: 'block' }}
    />
  );
};

export default JoinCodeQr;
